import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { DocumentService } from '@/services/admin/DocumentService'
// eslint-disable-next-line import/no-unresolved
import { errorMessage } from '@/utilities/helpers'
import { QueryBuilder } from '@/utilities/queryBuilder'

const { t } = i18n.global

export const namespaced = true

export const allowedSorts = '-created_at'

export const state = {
  documents: null,
  document: {},
  meta: null
}

export const mutations = {
  SET_DOCUMENTS(state, documents) {
    state.documents = documents.data
    state.meta = documents.meta
  },
  SET_DOCUMENT(state, document) {
    state.document = document
  }
}

export const actions = {
  getDocuments({ commit }, query) {
    return new Promise(resolve => {
      let documentService = new DocumentService()

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder

      _.forEach(query, function (value, filter) {
        if (filter !== 'page') {
          newQuery.where(filter, value)
        }
      })

      newQuery = queryBuilder.orderBy(allowedSorts).page(query.page).get()

      documentService.getDocuments(newQuery).then(response => {
        commit('SET_DOCUMENTS', response)
        resolve(response.data)
      })
    })
  },
  getDocument({ commit }, document) {
    return new Promise(resolve => {
      let documentService = new DocumentService()

      documentService.getDocument(document).then(response => {
        commit('SET_DOCUMENT', response.data)
        resolve(response.data)
      })
    })
  },
  upload({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      let documentService = new DocumentService()
      documentService
        .upload(form)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.uploading_error', {
                element: t('store.admin.document.document')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  markCancelledDocumentsAsShipped({ dispatch }, documents) {
    return new Promise((resolve, reject) => {
      let documentService = new DocumentService()
      documentService
        .markCancelledDocumentsAsShipped(documents)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.document.mark_cancelled_documents_as_shipped')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
